<header id="nav-bar-header">
  <div class="container">
    <nav class="navbar navbar-expand-lg">
      <a class="navbar-brand d-flex align-items-center" href="#">
        <img class="navbar-icon"
          src="assets/images/logo.svg"
          alt="CLOCC THAT TEA" />
      </a>

      <!-- <button class="navbar-toggler" type="button" (click)="toggleMenu()">
        <i class="fa-solid fa-bars-staggered"></i>
      </button> -->

      <button class="navbar-toggler" type="button" (click)="toggleMenu()">
        <div class="hamburger" [class.active]="isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <div class="d-lg-flex d-none gap-4 align-items-center">
        <a routerLink="/auth/login" class="base-btn gradient-btn-bottom">
          {{ sessionData?.isAuthenticated ? "Go To Login" : "Admin Login" }}
        </a>
        @if (sessionData?.isAuthenticated) {
        <div class="d-none d-lg-block" style="cursor: pointer">
          <a (click)="logout()" class=""> Logout </a>
        </div>
        }
      </div>
    </nav>

    <!-- Mobile Menu -->
    <div class="mobile-menu d-lg-none" [class.active]="isMenuOpen">
      <ul class="mobile-nav-list">
        @if (showMenu()) {
        <li class="nav-item">
          <a class="nav-link" href="landing-page#features">Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="landing-page#how-it-works">How it Works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="landing-page#Download">Download</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Contact</a>
        </li>
        }

        <!-- Mobile Auth Section -->
        <div class="mobile-auth-section">
          <li class="d-lg-none align-self-start">
            <a routerLink="/auth/login" class="mobile-nav-link mobile-cta">
              {{ sessionData?.isAuthenticated ? "Go To Login" : "Admin Login" }}
            </a>
          </li>
          @if (sessionData?.isAuthenticated) {
          <li class="d-lg-none align-self-start">
            <div class="d-block" style="cursor: pointer">
              <a (click)="logout()" class="mobile-nav-link mobile-cta-last">Logout</a>
            </div>
          </li>
          }
        </div>
      </ul>
    </div>
  </div>
</header>
